/** One candidate invoice in the manual matching dialog. */
export interface AccountingDocumentForMatch {
    id: number;
    invoiceNumber: string;
    invoiceDate: string;
    recipientFullName: string;
    totalAmount: number;
    paymentType: string;
    status: string;
    /** Already settled - still linkable, but no status change will follow. */
    alreadyPaid: boolean;
}

/** One live link between the statement and an invoice. */
export interface BankStatementMatch {
    /** The match row's id - what unlink is addressed to, not the document id. */
    id: number;
    accountingDocumentId: number;
    invoiceNumber: string;
    invoiceTotalAmount: number;
    /** What THIS statement put towards the invoice. */
    allocatedAmount: number;
    /** What every statement has put towards it - larger when several transfers pay one bill. */
    totalAllocatedToInvoice: number;
    matchSource: string;
    matchedOn: string;
    matchedByName: string;
}

/** What the dialog is opened with. */
export interface MatchDialogData {
    statementId: number;
    reference: string;
    amount: number;
    currency: string;
}

/** What it hands back - the list only needs to know whether to refresh. */
export interface MatchDialogResult {
    changed: boolean;
}

/** Payment types the automatic matcher settles: по банка and отложено плащане. */
export const BANK_PAYMENT_TYPE_IDS: number[] = [5, 6];
